const isDate = (value) => {
  const formatted = new Date(value);
  return (
    Object.prototype.toString.call(formatted) === '[object Date]' &&
    Number.isFinite(Number(formatted))
  );
};

export default isDate;
